import styled from "styled-components"
import responsive from "../../common/responsive"

const Section = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${props =>
    props.small
      ? responsive(
          "padding",
          "56px 20px",
          "56px 20px",
          "48px 20px",
          "48px 20px"
        )
      : responsive(
          "padding",
          "110px 16px",
          "110px 16px",
          "80px 16px",
          "64px 16px"
        )};
  ${props =>
    props.color && `background-color: ${props.theme.colors[props.color]};`};
`

export { Section as default }



// WEBPACK FOOTER //
// ./src/components/Section/index.js